import { useQuery } from "@apollo/client";
import { ReactElement } from "react";

import {
  GetAudienceContactFieldsQuery,
  GetAudienceContactQuery,
} from "~frontend/__generated__/graphql";
import { AsyncWrapper } from "~frontend/components/AsyncWrapper";
import { GET_AUDIENCE_CONTACT } from "~frontend/graphql/audience";

import { SearchResultWithContact } from "./AudienceSubscriberTable";
import AudienceContactDetailsDialog from "./Subscribers/AudienceContactDetailsDialog";
import SubscriberDialog from "./Subscribers/SubscriberDialog";
import { SubscriberAudience } from "./Subscribers/types";

export default function AudienceContactDialog({
  contact,
  onClose,
  audience,
  fieldDefinitions,
}: {
  contact: SearchResultWithContact;
  onClose: () => void;
  audience: SubscriberAudience;
  fieldDefinitions: GetAudienceContactFieldsQuery["getAudienceContactFields"];
}): ReactElement {
  const { data, loading, error, refetch } = useQuery<GetAudienceContactQuery>(
    GET_AUDIENCE_CONTACT,
    {
      variables: {
        input: {
          audienceId: audience.id,
          audienceContactId: contact.audienceContactId,
        },
      },
      skip: !contact,
    }
  );

  return (
    <AsyncWrapper data={data} loading={loading} errors={error}>
      {({ getAudienceContact }) => {
        if (getAudienceContact.subscriber) {
          return (
            <SubscriberDialog
              subscriber={getAudienceContact.subscriber}
              updateSubscriber={() => refetch()}
              subscriberAudience={audience}
              audienceContactFields={fieldDefinitions}
              onClose={onClose}
            />
          );
        }

        return (
          <AudienceContactDetailsDialog
            audienceContact={getAudienceContact}
            updateAudienceContact={() => refetch()}
            audienceId={audience.id}
            audienceContactFields={fieldDefinitions}
            onClose={onClose}
          />
        );
      }}
    </AsyncWrapper>
  );
}
